import { render, staticRenderFns } from "./LeadsEdit.vue?vue&type=template&id=95e4fc92"
import script from "./LeadsEdit.vue?vue&type=script&lang=js"
export * from "./LeadsEdit.vue?vue&type=script&lang=js"
import style0 from "./LeadsEdit.vue?vue&type=style&index=0&id=95e4fc92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports